import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../../Auth/apiService';
import { useAuth } from './../../../Auth/AuthContext';
import SeccionPageHeader from '../../Utils/SeccionPageHeader';
import CargandoSpinner from '../../Utils/CargandoSpinner';
import { FaFolder, FaShareAltSquare, FaRegFilePdf } from 'react-icons/fa';

export default function MenuArchivo(){
    const { token } = useAuth();
    const { idCabeza } = useParams();
    const [idCabezaFamilia, setIdCabezaFamilia] = useState('');
    const [nombre, setNombre] = useState('');
    const [carpetaarchivo, setCarpetaarchivo] = useState();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const {register, handleSubmit, formState: { errors }} = useForm();
    useEffect(() => {
        if(idCabeza !== "0"){
            onSubmit({identificacion: idCabeza});
        }
        
    }, []);
    const onSubmit = async (data) => {
        setCargando(true);
        try {
            const response = await apiService.post('/archivo/consultarcarpetapersona', {idCabezaFamilia: data.identificacion}, token);
            const result = await response.data;
            if (result.cabezafamilia?.cab_idcabezafamilia) {
                setIdCabezaFamilia(result.cabezafamilia.cab_idcabezafamilia);
                setNombre(result.cabezafamilia.nombre);
            } else {
                Mensaje('Archivo', 'la persona no se encuentra registrada en el sistema.');
                setIdCabezaFamilia('');
            }
            
            if(result.carpetaArchivoPersonaDTO.id){
                setCarpetaarchivo(result.carpetaArchivoPersonaDTO);
            }else{
                setCarpetaarchivo();
            }
            
        } catch (error) {
            Mensaje('Archivo', `Consulta persona. ${error.response.data}`);
        } finally {
          setCargando(false);
        }
      };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Archivo" idCabezaFamilia={"0"} url={'/archivo'} nombreurl="Archivo" nombreform="Archivo" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="row">
                            <div className="card-tools">
                                <NavLink to={`/bodega/descargaractas`} 
                                    className="btn btn-app bg-info" 
                                    data-tooltip-id="tooltiparriba"
                                    data-tooltip-content="Descargar actas">
                                    <FaRegFilePdf size={20}/><p>Descargar</p>
                                </NavLink>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-4">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div className="input-group">
                                                <input type='text' {...register('identificacion', { required: true })} className="form-control" placeholder="Identificacion"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-primary">Consultar persona</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                
                            </div>
                            {idCabezaFamilia !== '' && <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title m-0">Datos del Jefe de Hogar</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                    <div className="col-md-12">
                                        Nombre: <b>{nombre}</b>
                                    </div>
                                    </div>
                                    <div className="row">
                                    <div className="col-md-4">
                                        Identificacion: <b>{idCabezaFamilia}</b>
                                    </div>
                                    </div>
                                </div>
                            </div>}
                            {idCabezaFamilia !== '' && !carpetaarchivo && <div className='row'>
                                <div className='col-md-12'>
                                    <div className="card-header">
                                        <h4 className="card-title m-0">No hay carpetas registradas para este hogar.</h4>
                                    </div>
                                    </div>
                            </div>}
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-12 no-padding">
                                        {idCabezaFamilia !== '' && carpetaarchivo && <NavLink to={`/archivo/subirarchivo/${idCabezaFamilia}`} 
                                            className="btn btn-app bg-info" 
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Cargar archivo a carpeta">
                                            <FaRegFilePdf size={20}/><p>Cargar</p>
                                        </NavLink>}
                                        {idCabezaFamilia !== '' && !carpetaarchivo && <NavLink to={`/archivo/registrarcarpeta/${idCabezaFamilia}`} 
                                                className="btn btn-app bg-info" 
                                                data-tooltip-id="tooltiparriba"
                                                data-tooltip-content="Registrar carpeta">
                                                <FaFolder size={20}/><p>Registrar</p>
                                        </NavLink>}
                                        <NavLink hidden to={'/archivo/prestamos'} 
                                            className="btn btn-app bg-info" 
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Ver carpetas prestadas">
                                            <FaShareAltSquare size={20}/><p>Prestamos</p>
                                        </NavLink>
                                        <NavLink hidden to={'/archivo/movimientocarpetas'} 
                                            className="btn btn-app bg-info" 
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Movimiento de carpetas">
                                            <FaFolder size={20}/><p>Movimientos</p>
                                        </NavLink>
                                    </div> 
                                    {idCabezaFamilia !== '' && carpetaarchivo && <div className="col-md-1 no-padding">
                                        <NavLink hidden to={`/archivo/prestamocarpeta/${idCabezaFamilia}`} 
                                            className="btn btn-app bg-info" 
                                            data-tooltip-id="tooltiparriba"
                                            data-tooltip-content="Prestamo carpeta">
                                            <FaFolder size={20}/><p>Prestamo</p>
                                        </NavLink>
                                    </div>}
                                </div>
                            </div>
                            {/* /.card-header */}
                            <div className="card-body table-responsive p-0">
                                
                            </div>
                            {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                    </div>
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
            didClose={() => {
                setSwalProps({})
            }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}